import SectionCard from '@/components/molecule/SectionCard';
import Typo from '@/components/atom/Typo';
import React from 'react';
import { cn } from '@/src/utils';

interface DashboardCardProps {
  data: {
    key: string;
    value: string;
  }[];
}

function DashboardCard({ data }: DashboardCardProps) {
  return (
    <SectionCard
      contentProps={{
        className: `grid grid-cols-${data.length} py-[36px] divide-x`,
      }}
    >
      {data.map(({ key, value }) => {
        return (
          <div key={key} className={cn('flex flex-col pl-[32px]')}>
            <Typo typoType="b16m" className="text-gray-500">
              {key}
            </Typo>
            <Typo typoType="h26sb" className="text-gray-800">
              {value}
            </Typo>
          </div>
        );
      })}
    </SectionCard>
  );
}

export default DashboardCard;
